import React, { useState, useEffect } from 'react';
import { Globe, Wifi, Zap, RadioReceiver, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from '../styles/ConnectionPlans.module.css';

const ConnectionPlans = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
        return () => setIsVisible(false);
    }, []);

    const plansData = [
        {
            category: 'Օպտիկամանրաթելային կապ',
            icon: <Wifi size={28} className={styles.wifiIcon} />,
            plans: [
                {
                    id: 1,
                    name: 'Econom',
                    price: '5000',
                    currency: 'դրամ',
                    speed: '40 ՄԲԻԹ/ՎՐԿ',
                    feature: 'Անվճար WIFI ակտիվացում',
                    popular: false,
                    highlight: false
                },
                {
                    id: 2,
                    name: 'Standart',
                    price: '7000',
                    currency: 'դրամ',
                    speed: '70 ՄԲԻԹ/ՎՐԿ',
                    feature: 'Անվճար WIFI ակտիվացում',
                    popular: true,
                    highlight: true
                },
                {
                    id: 3,
                    name: 'Ultra',
                    price: '9000',
                    currency: 'դրամ',
                    speed: '100 ՄԲԻԹ/ՎՐԿ',
                    feature: 'Անվճար WIFI ակտիվացում',
                    popular: false,
                    highlight: false
                },
            ],
        },
        // {
        //     category: 'Ռադիոմոդեմային կապ',
        //     icon: <RadioReceiver size={28} className={styles.radioIcon} />,
        //     plans: [
        //         {
        //             id: 4,
        //             name: 'Էկոնոմ-6',
        //             price: '3800',
        //             currency: 'դրամ',
        //             speed: '25 ՄԲԻԹ/ՎՐԿ',
        //             feature: 'Անվճար WIFI ակտիվացում',
        //             popular: false,
        //             highlight: false
        //         },
        //         {
        //             id: 5,
        //             name: 'Մատչելի-10',
        //             price: '5000',
        //             currency: 'դրամ',
        //             speed: '40 ՄԲԻԹ/ՎՐԿ',
        //             feature: 'Անվճար WIFI ակտիվացում',
        //             popular: true,
        //             highlight: true
        //         },
        //         {
        //             id: 6,
        //             name: 'Արագ-20',
        //             price: '7000',
        //             currency: 'դրամ',
        //             speed: '60 ՄԲԻԹ/ՎՐԿ',
        //             feature: 'Անվճար WIFI ակտիվացում',
        //             popular: false,
        //             highlight: false
        //         },
        //     ],
        // },
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                when: "beforeChildren",
                staggerChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: {
                type: "spring",
                stiffness: 100,
                damping: 10
            }
        }
    };

    const cardHoverVariants = {
        hover: {
            y: -10,
            boxShadow: "0 15px 30px rgba(0, 0, 0, 0.15)",
            transition: {
                type: "spring",
                stiffness: 300
            }
        }
    };

    return (
        <section id="plans" >
        <AnimatePresence>
            {isVisible && (
                <motion.section
                    className={styles.wrapper}
                    initial="hidden"
                    animate="visible"
                    exit="hidden"
                    variants={containerVariants}
                >
                    <div className={styles.inner}>
                        <motion.header
                            className={styles.header}
                            variants={itemVariants}
                        >
                            <h1 className={styles.mainTitle}>
                                <motion.span
                                    className={styles.titleHighlight}
                                    initial={{ opacity: 0, x: -20 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ delay: 0.2 }}
                                >
                                    Կապի
                                </motion.span>{' '}
                                <motion.span
                                    initial={{ opacity: 0, x: 20 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ delay: 0.3 }}
                                >
                                    Պլաններ
                                </motion.span>
                            </h1>
                            <motion.p
                                className={styles.subtitle}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.4 }}
                            >
                                Ընտրեք Ձեզ համապատասխան պլանը
                            </motion.p>
                        </motion.header>

                        <div className={styles.plansContainer}>
                            {plansData.map((group, groupIndex) => (
                                <motion.section
                                    key={group.category}
                                    className={styles.categorySection}
                                    variants={itemVariants}
                                    initial="hidden"
                                    animate="visible"
                                    transition={{ delay: 0.2 + groupIndex * 0.1 }}
                                >
                                    <motion.div
                                        className={styles.categoryHeader}
                                        whileHover={{ x: 5 }}
                                    >
                                        <motion.div
                                            className={styles.iconWrapper}
                                            animate={{
                                                rotate: [0, 10, -10, 0],
                                                scale: [1, 1.1, 1.1, 1]
                                            }}
                                            transition={{
                                                delay: 0.5 + groupIndex * 0.2,
                                                duration: 0.6
                                            }}
                                        >
                                            {group.icon}
                                        </motion.div>
                                        <h2 className={styles.categoryTitle}>{group.category}</h2>
                                    </motion.div>

                                    <div className={styles.plansGrid}>
                                        {group.plans.map((plan, planIndex) => (
                                            <motion.article
                                                key={plan.id}
                                                className={`${styles.planCard} ${
                                                    plan.popular ? styles.popular : ''
                                                } ${plan.highlight ? styles.highlight : ''}`}
                                                variants={itemVariants}
                                                initial="hidden"
                                                animate="visible"
                                                transition={{ delay: 0.3 + planIndex * 0.1 }}
                                                whileHover="hover"
                                                variants={cardHoverVariants}
                                            >
                                                {plan.popular && (
                                                    <motion.div
                                                        className={styles.recommendedBadge}
                                                        initial={{ scale: 0 }}
                                                        animate={{ scale: 1 }}
                                                        transition={{
                                                            type: "spring",
                                                            stiffness: 500,
                                                            damping: 15,
                                                            delay: 0.4 + planIndex * 0.1
                                                        }}
                                                    >
                                                        <span>Առաջարկ</span>
                                                    </motion.div>
                                                )}

                                                <div className={styles.cardContent}>
                                                    <h3 className={styles.planName}>{plan.name}</h3>

                                                    <div className={styles.priceContainer}>
                                                        <motion.span
                                                            className={styles.priceValue}
                                                            initial={{ scale: 0.9 }}
                                                            animate={{ scale: 1 }}
                                                            transition={{ delay: 0.5 + planIndex * 0.1 }}
                                                        >
                                                            {plan.price}
                                                        </motion.span>
                                                        <span className={styles.priceCurrency}>{plan.currency}</span>
                                                        <span className={styles.pricePeriod}>/ամիս</span>
                                                    </div>

                                                    <div className={styles.divider} aria-hidden="true" />

                                                    <ul className={styles.featuresList}>
                                                        <li className={styles.featureItem}>
                                                            <motion.div
                                                                animate={{
                                                                    rotate: [0, 15, -15, 0],
                                                                    scale: [1, 1.2, 1.2, 1]
                                                                }}
                                                                transition={{
                                                                    delay: 0.6 + planIndex * 0.1,
                                                                    duration: 0.6
                                                                }}
                                                            >
                                                                <Zap className={styles.featureIcon} />
                                                            </motion.div>
                                                            <span>Մինչև <strong>{plan.speed}</strong></span>
                                                        </li>
                                                        <li className={styles.featureItem}>
                                                            <Wifi className={styles.featureIcon} />
                                                            <span>{plan.feature}</span>
                                                        </li>
                                                    </ul>


                                                </div>
                                            </motion.article>
                                        ))}
                                    </div>
                                </motion.section>
                            ))}
                        </div>
                    </div>
                </motion.section>
            )}
        </AnimatePresence>
        </section>
    );
};

export default ConnectionPlans;